export const customFacets = {
  customFacets: {
    filter: {
      errors: {
        fromBiggerThanTo: 'The "From" value should be lower than the "To" value',
      },
    },
  },
};
